export const css = {
    root: '_27hQ-FjV',
    loading: '_3dCoDKdC',
    titleBlock: 'C3c9nVaM',
    title: '_1pCRcoFi',
    gotitBlock: '_1rHR-gh8',
    gotit: '_3iSrg5ie',
    section: '_2z5M6r1E',
    hero: 'rOKvzhhS',
    heroBanner: '_2OGbyt8l',
    heroSubtitle: '-YPC-B30',
    heroIconList: '_3w_ZJhtZ',
    verticalAccordion: 'NPMZ3RUl',
    accordion: '_3zGpzqRj',
    horizontalAccordion: '_2yaQGMN7',
    storyline: '_2h9v8vvG',
    xref: '_3y1a0SLq',
    HCBullet: '_2aL8mLet',
    HCBulletStyle2: '_1lzGhHcv',
    TableUL: '_1zCb3w2l',
    figure: '_1eQd8BY4',
    nextprev: 'dVoL4k5e',
    next: '_28YnQh4T',
    previous: 'f19RTmVt',
    compactyes: '_2AAp1awI',
    ' _key': 'afcpe-theme/afcpe/book-widgets/topicpage'
};
export default css;
